<template>
  <div class="flex items-center justify-center w-max-content w-max col-span-full">
    <div class="relative inline-block align-middle">
      <info-bulle
        :libelle="labelLibelle"
        :name="name"
        :is-libelle-input="true"
      >
        <template #libelleBefore>
          <p
            v-if="libelle != null"
            :for="name"
            class="text-base text-gray-900 truncate mb-2"
            :style="(inherits != undefined && inherits != null && inherits) ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''"
            @mouseover="tooltipLibelle=true;"
            @mouseleave="tooltipLibelle=false;"
          >
            {{ libelle }}
          </p>
        </template>
        <template #tooltipLibelleBefore>
          <!-- Display libelle when hover -->
          <transition
            enter-active-class="duration-300 delay-1000"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-if="tooltipLibelle && libelle != null && libelle != ''"
              class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
            >
              {{ libelle }}
            </div>
          </transition>
        </template>
      </info-bulle>
    </div>
    <div class="relative ml-5 inline-block align-middle">
      <input 
        :name="name" 
        type="checkbox" 
        v-model="mutableValue" 
        class="appearance-none bg-opacity-25 h-green-checkbox w-green-checkbox rounded cursor-pointer"
        :class="{'bg-gray-600': !mutableValue, 'bg-teal-600': mutableValue, 'cursor-not-allowed': (disabled || disabled_pass)}"
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
      >
      <div
        v-if="!mutableValue"
        class="pointer-events-none inset-x-1 inset-y-3 absolute items-center text-gray-600"
      >
        <icon name="minus" />
      </div>
      <div
        v-else
        class="pointer-events-none inset-x-1 inset-y-1.5 absolute items-center text-teal-600"
      >
        <icon name="checkmark" />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';
import InfoBulle from '../../components/InfoBulle';

export default {
  components: {
    Icon,
    InfoBulle,
  },
  props: ['name', 'libelle', 'value', 'necessary', 'disabled', 'labelLibelle', 'inherits'],
  data: function () {
    return {
      mutableValue: this.value,
      disabled_pass: false,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle: false,
      progressCount:true,
    };
  },
  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass')){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if(this.$can(page+'_edit', idpass)){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if(this.necessary != undefined && !this.necessary){
      this.progressCount = false;
    }
  },
  methods:{
    displayLabelTooltip(e){
      if(e.x < (2*window.outerWidth/3)){
        document.querySelectorAll('.tooltip-label[name=\''+this.name+'\']')[0].classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },
    forceHideTooltipLabel(e){
      if(e.target.classList.contains('tooltip-label') && e.target.name == this.name){
        this.tooltipLabel = !this.tooltipLabel;
      }else{
        if(this.tooltipLabel)
          this.tooltipLabel = false;
      }
    },
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);
    },
    value(){
      this.mutableValue = this.value;
    }
  },
  directives: {
    clickOutside:{
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) { warn += `Found in component '${compName}'`; }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
